module.exports = __webpack_public_path__ + "img/live_mint.860f7e20.png";